module.exports = __webpack_public_path__ + "static/img/user_icon.9d50e4ca.png";